function leishTeg(){
    return{
        "games":[
            {
                "informs":[
                    {
                        "text":"No ambiente silvestre, os reservatórios da Leishmaniose Visceral variam de acordo com a região geográfica. Algumas espécies são:",
                        "title":"Quem está envolvido no ciclo da doença?",
                        "image":"images/games/informs/leishTeg/1.png"
                    },
                    {
                        "text":"rato (Bolomys <i>lasiurus</i> e Rattus <i>rattus</i>), gambá (Didelphis <i>albiventris</i>), preguiça, tamanduá, macacos (Chiropotes <i>satanas</i> e Cebus <i>apella</i>) e raposa.",
                        "title":"Quem está envolvido no ciclo da doença?",
                        "image":"images/games/informs/leishTeg/1.png"
                    },
                    {
                        "text":"No ambiente doméstico servem de reservatórios: cães, gatos e cavalos, que são afetados pela doença de forma similar à humana, mas, seu papel na manutenção do parasita no ambiente ainda não foi bem esclarecido.",
                        "title":"Quem está envolvido no ciclo da doença?",
                        "image":"images/games/informs/leishTeg/1.png"
                    }
                ],
                "pathImageGame":"midias/images/games/puzzles/leishTeg/1.jpg"
        },
        {
                "informs":[
                    {
                        "text":"Os causadores da Leishmaniose Visceral são espécies do gênero Leishmania.",
                        "title":"Quem causa a doença?",
                        "image":"images/games/informs/leishTeg/2.png"
                    },
                    {
                        "text":"Nas Américas, são reconhecidas onze espécies causadoras da doença humana e oito espécies descritas apenas em animais.",
                        "title":"Quem causa a doença?",
                        "image":"images/games/informs/leishTeg/2.png"
                    },
                    {
                        "text":" No Brasil existem sete dessas espécies, cujas principais são: L. <i>braziliensis</i>, L. <i>guyanensis</i> e L. <i>amazonensis</i> e, mais recentemente, as espécies L. <i>lainsoni</i>, L. <i>naiffi</i>, L. <i>lindenberg</i> e L. <i>shawi</i> foram identificadas em estados das regiões Norte e Nordeste.",
                        "title":"Quem causa a doença?",
                        "image":"images/games/informs/leishTeg/2.png"
                    }
                ],
                "pathImageGame":"midias/images/games/puzzles/leishTeg/2.jpg"
            },
        {
                "informs":[
                    {
                        "text":"A doença se manifesta sob duas formas: leishmaniose cutânea e leishmaniose mucosa.",
                        "title":"Quais os sintomas da doença?",
                        "image":"images/games/informs/leishTeg/3.png"
                    },
                    {
                        "text":"Na primeira, as lesões se desenvolvem na pele e assemelham-se a úlceras sendo únicas, múltiplas, disseminadas ou difusas, com bordas elevadas, fundo granuloso e geralmente são indolores. ",
                        "title":"Quais os sintomas da doença?",
                        "image":"images/games/informs/leishTeg/3.png"
                    },
                        {
                        "text":" Nas mucosas, as lesões são mais frequentes no nariz, boca e garganta. No nariz pode ocorrer entupimento, sangramento, coriza e aparecimento de crostas e feridas. Na garganta, dor ao engolir, rouquidão e tosse.",
                        "title":"Quais os sintomas da doença?",
                        "image":"images/games/informs/leishTeg/3.png"
                    }
                ],
                "pathImageGame":"midias/images/games/puzzles/leishTeg/3.jpg"
            },
        {
                
                "informs":[
                    {
                        "text":"A pessoa pega a doença quando a fêmea do mosquito Lutzomyia <i>flaviscutellata</i>, L. <i>whitmani</i>, L. <i>umbratilis</i>, L. <i>intermedia</i>, L. <i>wellcome</i> e L. <i>migonei</i> infectada com o parasita a pica.",
                        "title":"Como a doença é transmitida?",
                        "image":"images/games/informs/leishTeg/4.png"
                    },
                    {
                        "text":"A transmissão varia com a região geográfica, envolvendo diferentes espécies de parasitas, vetores, reservatórios e hospedeiros.",
                        "title":"Como a doença é transmitida?",
                        "image":"images/games/informs/leishTeg/4.png"
                    },
                        {
                        "text":"O hospedeiro intermediário do parasita é o inseto e os definitivos são: homem, cães, gatos e outros mamíferos, onde respectivamente ocorre sua reprodução assexuada e sexuada.",
                        "title":"Como a doença é transmitida?",
                        "image":"images/games/informs/leishTeg/4.png"
                    }
                ],
                "pathImageGame":"midias/images/games/puzzles/leishTeg/4.jpg"
            },
        {
                "informs":[
                    {
                        "text":"São medidas preventivas contra a doença: evitar que o mosquito se prolifere, eliminando água parada e limpa;",
                        "title":"Como fazer a prevenção?",
                        "image":"images/games/informs/leishTeg/5.png"
                    },
                    {
                        "text":"usar roupas de manga longa e calças compridas em atividades nos horários crepusculares cuja atividade do vetor é intensa;",
                        "title":"Como fazer a prevenção?",
                        "image":"images/games/informs/leishTeg/5.png"
                    },
                        {
                        "text":" usar telas em portas e janelas, mosquiteiros impregnados com inseticida e repelente na pele exposta seguindo a orientação do fabricante sobre o prazo para reaplicação do produto e controlar a população canina para prevenir a doença em cães.",
                        "title":"Como fazer a prevenção?",
                        "image":"images/games/informs/leishTeg/5.png"
                    }
                ],
                "pathImageGame":"midias/images/games/puzzles/leishTeg/5.jpg"
            }
        ]
    }
}

export{leishTeg};